import { useContext } from 'react';
import { LocaleContext } from './context';

export default function useLocale() {
  return useContext(LocaleContext);
}
